import { defineComponent, reactive, computed } from 'vue';
import { useRouter } from 'vue-router';
import { InformationImage } from '@hems/component';
import { Helper } from '@hems/util';
import IncreasingNumberLabel from '@/components/labels/IncreasingNumberLabel.vue';
export default defineComponent({
    name: 'ValueBox',
    components: {
        IncreasingNumberLabel,
        InformationImage,
    },
    props: {
        value: {
            type: [Number, String, null],
            required: false,
            default: null,
        },
        unit: {
            type: String,
            required: false,
            default: '',
        },
        text: {
            type: String,
            required: false,
            default: null,
        },
        showBtn: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
        btnPath: {
            type: String,
            required: false,
            default: null,
        },
        locale: {
            type: String,
            required: false,
            default: 'en',
        },
        decimal: {
            type: Number,
            required: false,
            default: 2,
        },
        width: {
            type: Number,
            required: false,
            default: 100,
        },
        height: {
            type: Number,
            required: false,
            default: 100,
        },
        detailMessageInfo: {
            type: Object,
            default: () => ({ isInfo: false, message: '' }),
        },
    },
    setup(props) {
        const state = reactive({
            isNumber: computed(() => typeof props.value === 'number'),
        });
        const router = useRouter();
        function onClick() {
            router.push({
                name: props.btnPath,
            });
        }
        return {
            state,
            Helper,
            onClick,
        };
    },
});
